type Listener = (...args: any) => void;

export class Subscribable {
  private listeners: Listener[] = [];

  public subscribe = (listener: Listener) => {
    this.listeners.push(listener);
    this.onSubscribe();
    return () => {
      this.unsubscribe(listener);
    };
  };

  public unsubscribe = (listener: Listener) => {
    this.listeners = this.listeners.filter(
      (oldListener) => oldListener !== listener,
    );
    this.onUnsubscribe();
  };

  public trigger = (...args: any[]) => {
    this.listeners.slice().forEach((listener: Listener) => listener(...args));
  };

  onSubscribe = () => {};
  onUnsubscribe = () => {};
}
